import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import LeadContactFormBlockData from 'app/Models/Content/LeadContactFormBlockData';
import LeadContactForm from './LeadContactForm';
import './LeadContactFormBlock.scss';

export default class LeadContactFormBlock extends EpiComponent<LeadContactFormBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['lead-contact-form-block'];
    return (
      <div className={cssClasses.join(' ')}>
        <LeadContactForm iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}

